import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _authService: AuthenticationService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let tahunAnggaran = localStorage.getItem('tahunAnggaran');
    const yearFormat = /^\d{4}$/;
    if (!yearFormat.test(tahunAnggaran)) {
      localStorage.removeItem('tahunAnggaran');
    }

    if (this._authService.isAuthenticated() && !this._authService.isExpired()) {
      if ((tahunAnggaran === null || tahunAnggaran === undefined || tahunAnggaran === '')) {
        this._router.navigate(['/tahun-anggaran']);
        return false;
      } else {
        return true;
      }
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class TahunAnggaranGuard implements CanActivate {
  constructor(private _router: Router, private _authService: AuthenticationService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let tahunAnggaran = localStorage.getItem('tahunAnggaran');
    const yearFormat = /^\d{4}$/;
    if (!yearFormat.test(tahunAnggaran)) {
      localStorage.removeItem('tahunAnggaran');
    }

    if (tahunAnggaran && tahunAnggaran !== '' && tahunAnggaran !== null && tahunAnggaran !== undefined) {
      return this._router.createUrlTree([`/${tahunAnggaran}/dashboard`]);
    } else {
      return this._router.createUrlTree(['/login']);
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class YearChangeGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = this.router.url;
    const newUrl = state.url;

    const currentRoute = currentUrl.split('/');
    const destinationRoute = newUrl.split('/');

    const [currentYear, newYear] = [currentRoute[1], destinationRoute[1]];
    const yearRegex = /^\d{4}$/;

    if (currentYear && newYear) {
      const defaultYear = localStorage.getItem('defaultYear');
      if (defaultYear !== newYear) {
        localStorage.setItem('defaultYear', newYear);
        if (currentUrl !== newUrl) {
          this.router.navigateByUrl(`/${newYear}`).then(() => {
            this.router.navigate([newUrl]);
          });
        }
        return false;
      }
    }
    return true;
  }
}